import { useState } from 'react'
import { Box, InputLabel, MenuItem, Select } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useTranslation } from 'react-i18next'
import { kybStatusEnum } from '../kyb.enums'
import { useUpdateCheckMutation } from '../../../services/guenoApi'

const KybEditCheckStatusModal = ({ checkId, defaultValue, onSubmit }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [_, { isLoading: updateCheckLoading }] = useUpdateCheckMutation({ fixedCacheKey: 'kyb-update-check' })
  const [newCheckStatus, setNewCheckStatus] = useState(defaultValue)

  return (
    <>
      <Box className="modal-box">
        <InputLabel htmlFor="status">{t('common:status')}:</InputLabel>
        <Select
          id="status"
          size="small"
          value={newCheckStatus}
          onChange={(e) => setNewCheckStatus(e.target.value)}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          {kybStatusEnum.map((item) => (
            <MenuItem key={item} value={item}>
              {t(`common:${item}`)}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box className="modal-button">
        <LoadingButton
          size="small"
          variant="contained"
          onClick={() => onSubmit(checkId, { status: newCheckStatus })}
          loading={updateCheckLoading}
        >
          {t('common:save')}
        </LoadingButton>
      </Box>
    </>
  )
}

export default KybEditCheckStatusModal
